import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download, FileText, Database, CheckCircle, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { getStatusInfo } from './payrollExportsHelpers';

const PayrollExportsOptionsCards = ({
  selectedPeriod,
  exportingCSV, handleExportCSV,
  exportingAccounting, handleExportAccounting,
}) => {
  const { t } = useTranslation();
  const canExport = getStatusInfo(selectedPeriod.status).canExport;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            {t('payrollExp.csvCard')}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="text-sm text-muted-foreground mb-3">
              {t('payrollExp.csvDesc')}
            </p>
            <div className="space-y-2 text-xs text-muted-foreground">
              <p>• {t('payrollExp.csvB1')}</p>
              <p>• {t('payrollExp.csvB2')}</p>
              <p>• {t('payrollExp.csvB3')}</p>
              <p>• {t('payrollExp.csvB4')}</p>
            </div>
          </div>
          <Button onClick={handleExportCSV} disabled={exportingCSV || !canExport} className="w-full flex items-center gap-2">
            {exportingCSV ? (
              <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current" /> {t('payrollExp.exporting')}</>
            ) : (
              <><Download className="h-4 w-4" /> {t('payrollExp.downloadCsv')}</>
            )}
          </Button>
          {selectedPeriod.status === 'CLOSED' && (
            <div className="flex items-center gap-2 text-xs text-green-600">
              <CheckCircle className="h-4 w-4" />
              <span>{t('payrollExp.closedNote')}</span>
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Database className="h-5 w-5" />
            {t('payrollExp.acctCard')}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="text-sm text-muted-foreground mb-3">
              {t('payrollExp.acctDesc')}
            </p>
            <div className="space-y-2 text-xs text-muted-foreground">
              <p>• {t('payrollExp.acctB1')}</p>
              <p>• {t('payrollExp.acctB2')}</p>
              <p>• {t('payrollExp.acctB3')}</p>
              <p>• {t('payrollExp.acctB4')}</p>
            </div>
          </div>
          <Button onClick={handleExportAccounting} disabled={exportingAccounting || !canExport} className="w-full flex items-center gap-2" variant="outline">
            {exportingAccounting ? (
              <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current" /> {t('payrollExp.exporting')}</>
            ) : (
              <><Database className="h-4 w-4" /> {t('payrollExp.acctCard')}</>
            )}
          </Button>
          {selectedPeriod.status === 'APPROVED' && (
            <div className="flex items-center gap-2 text-xs text-orange-600">
              <AlertCircle className="h-4 w-4" />
              <span>{t('payrollExp.approvedNote')}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PayrollExportsOptionsCards;
